<template>
  <div class="payCard">
    <div class="interestCard">
      <div class="headerDiv">
        <div class="headerInfo">
          <div class="headerText">
            <div>{{ Number(this.type) === 1 ? "每月应还" : "首月应还" }}</div>
            <img
              @click="$router.push('/issues')"
              class="headerIcon"
              src="https://static-official.5i5j.com/offical/cdn/f921736c7df88b4e4bc9a0bae6813cc4_1731576682665.png"
            />
          </div>
          <div class="headerPrice">
            <div>
              {{
                Number(this.type) === 1
                  ? this.epI.epiFirstMonth.mPay
                  : this.ep.epFirstMonth.mPay
              }}
            </div>
            <div class="yuan">元</div>
          </div>
        </div>
        <img
          class="headerImg"
          :src="
            Number(this.type) === 1
              ? 'https://static-official.5i5j.com/offical/cdn/9c1b3410342b64a1ec3e309c12d566e0_1731576318444.png'
              : 'https://static-official.5i5j.com/offical/cdn/90261a3c9fab3b4751d34922800aa5aa_1732152225474.png'
          "
        />
      </div>
      <div class="headerTag">
        <div class="tagDiv">
          <div class="tagTitle">贷款总额</div>
          <div class="tagPrice">
            {{
              Number(this.type) === 1
                ? (Number(this.epI.totalPrincipal) / 10000).toFixed(2)
                : (Number(this.ep.totalPrincipal) / 10000).toFixed(2)
            }}万
          </div>
        </div>
        <div class="tagDiv">
          <div class="tagTitle">利息总额</div>
          <div class="tagPrice">
            {{
              Number(this.type) === 1
                ? (Number(this.epI.totalInter) / 10000).toFixed(2)
                : (Number(this.ep.totalInter) / 10000).toFixed(2)
            }}万
          </div>
        </div>
        <div class="tagDiv">
          <div class="tagTitle">贷款年限</div>
          <div class="tagPrice">
            {{
              Number(this.type) === 1 ? this.epI.totalYear : this.ep.totalYear
            }}年
          </div>
        </div>
      </div>
    </div>
    <div class="tips">
      <span style="color: #d87f00">{{
        Number(this.type) === 1 ? tips[0].title : tips[1].title
      }}</span
      ><span style="color: #999999">{{
        Number(this.type) === 1 ? tips[0].text : tips[1].text
      }}</span>
    </div>
  </div>
</template>
<script>
export default {
  name: "PayCard",
  props: {
    // 1 等额本息 2 等额本金
    type: {
      type: Number,
      require: true,
    },
    epI: {
      type: Object,
      require: true,
    },
    ep: {
      type: Object,
      require: true,
    },
  },
  data() {
    return {
      tips: [
        {
          title: "每月还款额度不变",
          text: "，其中月供本金每月增加，月供利息每月减少。计算结果仅供参考，请以银行实际还款为准。",
        },
        {
          title: `每月还款额度递减${this.ep.totalDiff}元`,
          text: "，其中月供本金每月不变，月供利息每月减少。计算结果仅供参考，请以银行实际还款为准。",
        },
      ],
    };
  },
};
</script>
<style scoped>
@font-face {
  font-family: "Bebas";
  src: url("../../assets/BEBAS___.TTF");
}
.payCard {
  border-top-right-radius: 12px;
  border-top-left-radius: 12px;
  background: #fff;
  margin-left: 18px;
  margin-right: 18px;
  margin-top: 16px;
}
.interestCard {
  height: 322px;
  background: rgba(255, 249, 229, 0.4);
  border-radius: 12px;
  border: 2px solid #ffffff;
  padding-left: 40px;
  padding-top: 32px;
}
.headerDiv {
  height: 176px;
  position: relative;
  display: flex;
  margin-bottom: 24px;
}
.headerImg {
  width: 176px;
  height: 176px;
  position: absolute;
  top: -32px;
  right: 0;
}
.headerInfo {
  width: 280px;
  height: 176px;
}
.headerText {
  font-weight: 400;
  font-size: 28px;
  color: #999999;
  line-height: 40px;
  display: flex;
  justify-self: flex-start;
  align-items: center;
}
.headerIcon {
  margin-left: 12px;
  width: 24px;
}
.headerPrice {
  width: 280px;
  height: 86px;
  font-size: 64px;
  display: flex;
  color: #d87f00;
  line-height: 86px;
  font-family: "Bebas", sans-serif;
}
.yuan {
  margin-left: 8px;
  margin-top: 30px;
  font-weight: 400;
  font-size: 32px;
  color: #e8b162;
  line-height: 44px;
}
.headerTag {
  width: 600px;
  height: 96px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.tagTitle {
  font-weight: 400;
  font-size: 28px;
  color: #222222;
  line-height: 40px;
  text-align: left;
}
.tagPrice {
  font-weight: 400;
  font-size: 40px;
  color: #222222;
  line-height: 56px;
}
.tips {
  padding: 40px;
  font-size: 26px;
  line-height: 36px;
}
</style>
